export enum RibbonColor {
  ORANGE,
  BEIGE,
  BLUE,
  GREEN,
  BROWN,
  MAGENTA,
  GREY
}

